import { DataState } from '../state';
import { origin as originSel } from '../dataSelectors';

export const origin = {
  ...originSel,
  origin: (s: DataState) => s.auth.origin,
};
